export enum MerchantUserEnum {
    MERCHANT = 'MERCHANT',
    STAFF = "STAFF"
}